import React, { useState, useEffect } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { sessionPing } from './webServices';

const GuardedUserRoute = () => {
  const [auth, setAuth] = useState(null);
  const [sessionExpiration, setSessionExpiration] = useState(null);
  
  useEffect(() => {
    validateSession(setAuth, setSessionExpiration);
  }, []);

  if (auth === null) {
    return <div>Loading...</div>;
  }

  return auth ? <Outlet sessionExpiration={sessionExpiration} /> : <Navigate to="/" replace />;
};

const GuardedUserLogin = () => {
  const [auth, setAuth] = useState(null);
  const [sessionExpiration, setSessionExpiration] = useState(null);
  
  useEffect(() => {
    validateSession(setAuth, setSessionExpiration);
  }, []);

  if (auth === null) {
    return <div>Loading...</div>;
  }

  return !auth ? <Outlet sessionExpiration={sessionExpiration} /> : <Navigate to="/dashboard" replace={true} sessionExpiration={sessionExpiration} />;
};

const validateSession = async (setAuth, setSessionExpiration) => {
  try {
    const response = await sessionPing();
    if (response.data.valid) {
      setAuth(true);
      setSessionExpiration(response.data.expiration);
    } else {
      setAuth(false);
    }
  } catch (error) {
    console.error("Session validation error:", error);
    setAuth(false);
  }
};

export { GuardedUserRoute, GuardedUserLogin };
